import { Fragment, ReactNode } from "react";
import { NavMenu } from "./NavMenu";

export const Layout = (props: { children: ReactNode }) => {
  return (
    <Fragment>
      <NavMenu />
      {!(
        typeof window !== "undefined" &&
        (window.location.hostname === "ok2play.net.au" ||
          window.location.hostname === "www.ok2play.net.au")
      ) && (
        <div className="text-center text-red-700 font-extrabold text-xl py-3">
          THIS IS THE DEVELOPER WEBSITE AND MAY NOT BE WORKING
        </div>
      )}
      {props.children}
    </Fragment>
  );
};
